// Angle (deg, 0 = top) of a weighted segment's center — mirrors mobile wheelSegmentCenterDeg.
export function wheelSegmentCenterDeg(segments, index) {
  const total = segments.reduce((s, seg) => s + seg.weight, 0) || 1;
  let cursor = 0;
  for (let i = 0; i < segments.length; i++) {
    const sweep = (segments[i].weight / total) * 360;
    if (i === index) return cursor + sweep / 2;
    cursor += sweep;
  }
  return 0;
}

const COLORS = ["#2E5C45", "#438263", "#D6A419", "#B5651D", "#1B4F72", "#7C3A2D"];

function polar(cx, cy, r, angleDeg) {
  const rad = ((angleDeg - 90) * Math.PI) / 180;
  return { x: cx + r * Math.cos(rad), y: cy + r * Math.sin(rad) };
}
function wedgePath(cx, cy, r, startDeg, endDeg) {
  const start = polar(cx, cy, r, endDeg);
  const end = polar(cx, cy, r, startDeg);
  const largeArc = endDeg - startDeg <= 180 ? 0 : 1;
  return `M ${cx} ${cy} L ${start.x} ${start.y} A ${r} ${r} 0 ${largeArc} 0 ${end.x} ${end.y} Z`;
}

export default function Wheel({ segments, size = 260, rotation = 0, spinning = false }) {
  const r = size / 2;
  const total = segments.reduce((s, seg) => s + seg.weight, 0) || 1;
  let cursor = 0;
  const wedges = segments.map((seg, i) => {
    const sweep = (seg.weight / total) * 360;
    const startDeg = cursor;
    const endDeg = cursor + sweep;
    cursor = endDeg;
    const mid = (startDeg + endDeg) / 2;
    const labelPos = polar(r, r, r * 0.62, mid);
    return { seg, i, mid, labelPos, path: wedgePath(r, r, r - 3, startDeg, endDeg) };
  });

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <div className="absolute left-1/2 top-[-4px] z-10 h-0 w-0 -translate-x-1/2" style={{ borderLeft: "10px solid transparent", borderRight: "10px solid transparent", borderBottom: "16px solid #1C1C1E" }} />
      <div style={{ width: size, height: size, transform: `rotate(${rotation}deg)`, transition: spinning ? "transform 3.2s cubic-bezier(0.17,0.67,0.25,1)" : "none" }}>
        <svg width={size} height={size}>
          {wedges.map(({ seg, i, path }) => (
            <path key={`${seg.key}-${i}`} d={path} fill={COLORS[i % COLORS.length]} stroke="#FFFFFF" strokeWidth={2} />
          ))}
          {wedges.map(({ seg, i, labelPos, mid }) => (
            <text key={`l-${i}`} x={labelPos.x} y={labelPos.y} fill="#FFFFFF" fontSize="10" fontWeight="600" textAnchor="middle" dominantBaseline="middle" transform={`rotate(${mid}, ${labelPos.x}, ${labelPos.y})`}>
              {seg.label}
            </text>
          ))}
          <circle cx={r} cy={r} r={r * 0.17} fill="#D6A419" stroke="#FFFFFF" strokeWidth={3} />
        </svg>
      </div>
    </div>
  );
}
